var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Thêm Media Link vào lớp",
        visible: _vm.dialogVisible,
        width: "80%",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-table",
        {
          ref: "multipleTable",
          attrs: {
            "highlight-current-row": "",
            data: _vm.mediaForClassData,
            "header-cell-style": _vm.tableHeaderColor,
            "max-height": _vm.$tableMaxHeight,
            border: "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              label: "STT",
              width: "50",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "mediaName", label: "Tên media", width: "200" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "scopeType",
              label: "Phạm vi",
              width: "150",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "linkMedia", label: "Media Link" },
          }),
          _c("el-table-column", {
            attrs: { label: "Sủ dụng", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-checkbox", {
                      model: {
                        value: scope.row.used,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "used", $$v)
                        },
                        expression: "scope.row.used",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "medium" },
              on: {
                click: function ($event) {
                  return _vm.closeDialogByButton("mediaForClassData")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _c("span", [_vm._v("Đóng")]),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "success",
                size: "medium",
                loading: _vm.loadingButton,
                mini: "",
              },
              on: {
                click: function ($event) {
                  return _vm.submitForm("mediaForClassData")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-check" }),
              _c("span", [_vm._v("Lưu")]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }